import React from 'react';
import { Profile } from '@/types/auth';
import { Image as ImageIcon } from 'lucide-react';

interface BannerWidgetProps {
  profile: Profile;
}

export const BannerWidget: React.FC<BannerWidgetProps> = ({ profile }) => {
  if (!profile.banner_image_url) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-primary/5 to-primary/10">
        <div className="text-center text-muted-foreground">
          <ImageIcon className="h-8 w-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No banner image</p>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${profile.banner_image_url})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
    </div>
  );
};